import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { primaryText } from 'styles/theme';

export const StyledNavLink = styled(NavLink)`
    display: inline-flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
    font-size: 14px;

    &,
    &:visited,
    &:active {
        color: ${primaryText};
        text-decoration: none;
    }
` as NavLink;
